"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XalInternalError = void 0;

var XalInternalError =
/** @class */
function (_super) {
  __extends(XalInternalError, _super);

  function XalInternalError(errorType, message) {
    var _this = _super.call(this, "XAL internal error: " + errorType + ": " + message) || this;

    _this.errorType = errorType;
    return _this;
  }

  return XalInternalError;
}(Error);

exports.XalInternalError = XalInternalError;